import React, { useEffect, useState } from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';

const ControlCenterProtectedRoute = () => {
  const location = useLocation();

  const [status, setStatus] = useState('checking');
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const verifyAdmin = async () => {
      const token =
        localStorage.getItem('vakra_control_admin_token') ||
        sessionStorage.getItem('vakra_control_admin_token');

      if (!token) {
        if (!cancelled) {
          setStatus('unauthorized');
        }
        return;
      }

      try {
        const response = await fetch(
          `${window.location.origin}/api/control-center/me`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.admin) {
          throw new Error('Unauthorized');
        }

        if (!cancelled) {
          setAdmin(data.admin);
          setStatus('authorized');
        }
      } catch (error) {
        localStorage.removeItem('vakra_control_admin_token');
        localStorage.removeItem('vakra_control_admin');

        sessionStorage.removeItem('vakra_control_admin_token');
        sessionStorage.removeItem('vakra_control_admin');

        if (!cancelled) {
          setStatus('unauthorized');
        }
      }
    };

    verifyAdmin();

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: '#06101f',
          color: '#ffffff',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        Verifying secure session...
      </div>
    );
  }

  if (status === 'unauthorized') {
    return (
      <Navigate
        to="/control-center/login"
        replace
        state={{
          from: location.pathname,
        }}
      />
    );
  }

  return <Outlet context={{ admin }} />;
};

export default ControlCenterProtectedRoute;
